module.exports = __webpack_public_path__ + "static/img/gamelist11.e7233c58.png";